var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('button',{on:{"click":_vm.onPaylateClick}},[_vm._v(" "+_vm._s(_vm.$t('paylateBtn'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }